import React from "react";
import { Navigate, useParams } from "react-router-dom";

import ProjectWrapper from "../../components/project/ProjectWrapper";
import Profile from "../profile/Profile";
import GlobalWrapper from "../../components/global/GlobalWrapper";
import RequireAuth from "../../components/auth/RequireAuth";
import { isValidProfileSlug } from "../../constant/reservedSlugs";
import { UUID_PATTERN } from "../../utils/uuid";

/**
 * ルート直下の 1 セグメントパス（`soremo.jp/{segment}`）の振り分け。
 *
 * - UUID 形式 → プロジェクト詳細（要認証・ヘッダーあり）
 * - slug 形式 → クリエイター公開プロフィール（認証不要・ヘッダーなし）
 * - どちらでもない（予約語・不正形式）→ サインインへ
 *
 * ケースごとに認証要否とヘッダー表示が異なるため、routes.tsx のスキーマでは
 * `raw` 指定とし、RequireAuth / GlobalWrapper はここで自前で巻く。
 * ルートパラメータ名は ProjectWrapper が `useParams().projectId` を参照する
 * ため `:projectId` のまま維持する。
 */
const RootSegmentDispatcher: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const segment = projectId ?? "";

  if (UUID_PATTERN.test(segment)) {
    return (
      <RequireAuth>
        <GlobalWrapper>
          {/* プロジェクト切り替え（⌥[ / ⌥] 等）で projectId が変わったとき、
              前プロジェクトのタブ state が残らないよう key で再マウントする */}
          <ProjectWrapper key={segment} />
        </GlobalWrapper>
      </RequireAuth>
    );
  }
  if (isValidProfileSlug(segment)) {
    return (
      <GlobalWrapper isHideTopBar>
        <Profile slug={segment} />
      </GlobalWrapper>
    );
  }
  return <Navigate to="/signin" replace />;
};

export default RootSegmentDispatcher;
